// src/utils/nativeBridge.js
import { writeLog } from './_discordLog';

export const isInNativeApp =
  typeof window !== 'undefined' &&
  window.navigator.userAgent.indexOf('uniprosperity') > -1;

export const requestOCAToken = () => {
  try {
    window.webkit.messageHandlers.requestOCAToken.postMessage('');
  } catch (err) {}

  try {
    UniProsperityMobileApp.requestOCAToken();
  } catch (err) {}
};

export const requestAuthToken = () => {
  const env = process.env.GATSBY_USE_ENV || 'unknown';
  writeLog(`[${env}] 呼叫 requestAuthToken`);

  try {
    window.webkit.messageHandlers.requestAuthToken.postMessage('');
  } catch (err) {}

  try {
    UniProsperityMobileApp.requestAuthToken('');
  } catch (err) {}
};

export const onSignIn = () => {
  try {
    window.webkit.messageHandlers.onSignIn.postMessage('');
  } catch (err) {}

  try {
    UniProsperityMobileApp.onSignIn();
  } catch (err) {}
};

export const updateAuthToken = (encodedParams) => {
  try {
    window.webkit.messageHandlers.updateAuthToken.postMessage(encodedParams);
  } catch (err) {}

  try {
    UniProsperityMobileApp.updateAuthToken(encodedParams);
  } catch (err) {}
};

export const requestRefreshAuthToken = () => {
  try {
    window.webkit.messageHandlers.requestRefreshAuthToken.postMessage('');
  } catch (err) {}

  try {
    UniProsperityMobileApp.requestRefreshAuthToken('');
  } catch (err) {}
};
